import { apiService } from './api.js';

/**
 * Facebook service for handling Facebook and WhatsApp Business API integration
 */
export const facebookService = {
  /**
   * Call Facebook callback endpoint with WhatsApp Business data
   * @param {Object} callbackData - Callback data from Facebook
   * @param {string} callbackData.code - Authorization code from Facebook
   * @param {string} callbackData.projectId - Project ID
   * @param {string} callbackData.whatsappBusinessAccountId - WhatsApp Business Account ID
   * @param {string} callbackData.phoneNumberId - Phone Number ID
   * @param {string} callbackData.businessId - Business ID
   * @returns {Promise<Object>} API response
   */
  facebookCallback: async callbackData => {
    const requestBody = {
      code: callbackData.code,
      projectId: callbackData.projectId,
      whatsappBusinessAccountId: callbackData.whatsappBusinessAccountId,
      phoneNumberId: callbackData.phoneNumberId,
      businessId: callbackData.businessId,
    };

    const response = await apiService.post('/facebook/callback', requestBody);
    return response;
  },

  /**
   * Legacy method for backward compatibility
   * @param {Object} whatsappData - WhatsApp connection data
   * @returns {Promise<Object>} API response
   */
  whatsappConnect: async whatsappData => {
    const response = await apiService.post('/facebook/callback', whatsappData);
    return response;
  },

  /**
   * Get Facebook app configuration
   * @returns {Promise<Object>} Facebook app configuration
   */
  getFacebookConfig: async () => {
    const response = await apiService.get('/facebook/config');
    return response;
  },

  /**
   * Get WhatsApp Business accounts
   * @returns {Promise<Object>} WhatsApp Business accounts
   */
  getWhatsAppAccounts: async () => {
    const response = await apiService.get('/facebook/whatsapp-accounts');
    return response;
  },

  /**
   * Disconnect WhatsApp Business account
   * @param {string} accountId - WhatsApp Business Account ID
   * @returns {Promise<Object>} API response
   */
  disconnectWhatsApp: async accountId => {
    const response = await apiService.delete(
      `/facebook/whatsapp-accounts/${accountId}`
    );
    return response;
  },
};

export default facebookService;
